<template>
    <span>
        {{ label }}
    </span>
</template>

<script>
    export default  {
        props: {
            fieldIds: Array,
            artisticFields: Array,
        },
        computed: {
            label() {
                return (this.fieldIds || []).map(fieldId => {
                    const field = this.getArtisticField(fieldId);
                    return field.name;
                }).join(', ');
            },
        },
        methods: {
            getArtisticField(id) {
                return this.artisticFields.find(field => field.id === id);
            },
        }
    }
</script>